// The ?cohort= / ?from= / ?to= (months) and ?basis= in a Hub ▸ Marketing ▸
// Journeys address (slice S3) — pure, no imports, so the API's offline gate
// (qa-marketing-s3) runs it. Anything unknown or malformed falls back to the
// last 3 full months and "how clients found us", so a pasted or old link never
// breaks the page.

export type CohortPreset = "last_3" | "last_6" | "last_12" | "this_month" | "custom";
export const COHORT_VALUES: readonly CohortPreset[] = ["last_3", "last_6", "last_12", "this_month", "custom"];
export type Basis = "found_us" | "last_click";
export interface CohortState { preset: CohortPreset; from: string; to: string; basis: Basis }

const MONTH = /^20\d{2}-(0[1-9]|1[0-2])$/;
export const isMonth = (s: string | null | undefined): s is string => !!s && MONTH.test(s);

export function parseCohortParams(get: (k: string) => string | null, today: string): CohortState {
  const raw = get("cohort");
  const preset: CohortPreset = raw && (COHORT_VALUES as readonly string[]).includes(raw) ? (raw as CohortPreset) : "last_3";
  const basis: Basis = get("basis") === "last_click" ? "last_click" : "found_us";
  const thisMonth = today.slice(0, 7);
  const from = get("from"); const to = get("to");
  if (preset === "custom") {
    if (isMonth(from) && isMonth(to) && from <= to && to <= thisMonth) return { preset, from, to, basis };
    return { preset: "last_3", from: thisMonth, to: thisMonth, basis };
  }
  return { preset, from: isMonth(from) ? from : thisMonth, to: isMonth(to) ? to : thisMonth, basis };
}

export function cohortQuery(c: CohortState): string {
  return `${c.preset === "custom" ? `cohort=custom&from=${c.from}&to=${c.to}` : `cohort=${c.preset}`}&basis=${c.basis}`;
}
